import { ContentWrapper, PrivateRoute, PublicRoute, Sider } from '@/components';
import MobileHeader from '@/components/MobileHeader';
import { useGodModeHotkey } from '@/hooks/useGodModeHotkey';
import { privateRoutes, publicRoutes } from '@/routes';
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from '@/routes/routes';
import { useGetRoutesWithPermissions } from '@/routes/useGetRoutesWithPermissions';
import { CustomLayout, LayoutType, Loading } from '@amili-v3/amili-v3-design';
import { useMobile } from '@amili-v3/amili-v3-design/src/hooks/useMobile';
import { Suspense } from 'react';
import { Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { MaxWidthWrapper } from './styles';
import './styles.scss';
import { useGetMe } from '@/hooks/useGetProfileQuery';
import { SSOCallback } from '@/pages/noAuthenPages';

const Router = () => {
  const { isLoading: loading } = useGetMe();
  const { routes: dashboardRoutes } = useGetRoutesWithPermissions();
  useGodModeHotkey();

  const isMobile = useMobile();

  return (
    <>
      <Routes>
        {/* Outside PublicRoute/PrivateRoute: it runs on the bare host, whose
            own sign-in state (the AMILI tenant) has nothing to do with the
            tenant being signed into. */}
        <Route path={PUBLIC_ROUTES.SSO_CALLBACK} element={<SSOCallback />} />

        <Route
          path="/"
          element={
            <PublicRoute>
              <CustomLayout
                type={LayoutType.CONTENT_ONLY}
                sider={isMobile ? <MobileHeader /> : <Sider />}
              >
                <Suspense>
                  <Outlet />
                </Suspense>
              </CustomLayout>
            </PublicRoute>
          }
        >
          {publicRoutes.map(route => {
            const Page = route.component;
            return (
              <Route key={route.path} path={route.path} element={<Page />} />
            );
          })}
          <Route path="/" element={<Navigate to={PRIVATE_ROUTES.APP} />} />
        </Route>

        <Route
          path="/"
          element={
            <PrivateRoute>
              <MaxWidthWrapper>
                <CustomLayout
                  type={isMobile ? LayoutType.MOBILE : LayoutType.DEFAULT}
                  padding={20}
                  sider={<Sider />}
                  header={<MobileHeader />}
                >
                  <ContentWrapper>
                    {loading ? (
                      <Loading />
                    ) : (
                      <Suspense>
                        <Outlet />
                      </Suspense>
                    )}
                  </ContentWrapper>
                </CustomLayout>
              </MaxWidthWrapper>
            </PrivateRoute>
          }
        >
          {privateRoutes.map(route => {
            const { path, component: Page } = route;
            return <Route key={path} path={path} element={<Page />} />;
          })}

          {dashboardRoutes.map(route => {
            const { path, component: Page } = route;
            return <Route key={path} path={path} element={<Page />} />;
          })}
          <Route path="/" element={<Navigate to={PRIVATE_ROUTES.APP} />} />
        </Route>

        <Route path="*" element={<Navigate to={PRIVATE_ROUTES.APP} />} />
      </Routes>
    </>
  );
};

export default Router;
